/**
 * @desc OA同步用户数据接口(新增)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.UserDataRequest>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/sync/user',
    data,
  });
}

export function mock(
  data: Array<defs.UserDataRequest>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/sync/user',
    data,
  });
}
